import React, { useContext } from "react";

import {
  getRoutePath,
  URLFormat,
  ClientRouteName,
} from "@every.org/common/src/helpers/clientRoutes";
import { consumeAdminInviteTokenRouteSpec } from "@every.org/common/src/routes/me";

import { REDIRECT_URL_QUERY_PARAM } from "src/components/Login/LoginForm";
import { Redirect } from "src/components/Redirect";
import { AuthContext } from "src/context/AuthContext";
import { isValidLoginRedirectUrl } from "src/context/AuthContext/actions";
import { AuthStatus } from "src/context/AuthContext/types";
import { useEdoRouter } from "src/hooks/useEdoRouter";
import { queryApi } from "src/utility/apiClient";
import { getAndDecodeSearchParam } from "src/utility/helpers";

export const RedirectHandler: React.FCC = ({ children }) => {
  const { search } = useEdoRouter();
  const authState = useContext(AuthContext);
  const searchParams = new URLSearchParams(search);

  if (authState.status === AuthStatus.LOGGED_IN) {
    // Redirect url
    const paramsRedirectUrl = getAndDecodeSearchParam(
      searchParams,
      REDIRECT_URL_QUERY_PARAM
    );
    const redirectUrl =
      paramsRedirectUrl && isValidLoginRedirectUrl({ url: paramsRedirectUrl })
        ? paramsRedirectUrl
        : getRoutePath({
            format: URLFormat.RELATIVE,
            name: ClientRouteName.HOME,
          });
    const inviteToken = getAndDecodeSearchParam(searchParams, "inviteToken");
    if (inviteToken) {
      queryApi(consumeAdminInviteTokenRouteSpec, {
        body: { adminInviteToken: inviteToken },
        routeTokens: {},
        queryParams: {},
      });
      return <Redirect to={redirectUrl} />;
    }
    return <Redirect to={redirectUrl} />;
  }
  return children;
};
